var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project"},[_vm._v(" project ")])
}
var staticRenderFns = []

export { render, staticRenderFns }